export default __webpack_public_path__ + "static/media/stock_plan_light.647d23ad.png";